module.exports = __webpack_public_path__ + "img/pyramid-four.9333c555.svg";